import React from 'react'
import { SearchWithExtras } from 'generated/api'
import { format } from 'date-fns'
import useResize from '../../../../lib/hooks/useResize'
import { SearchSummaryContent } from './internals/InnerContent'
import { Arrow } from '../icons/assets'
import { COLORS, PAGE_BREAKPOINTS } from 'parameters/index'
import { CallToActionButton } from './internals/CtaButtons'
import { determineSearchType, SearchType } from './internals/helpers'
import { Card, CardWrapper } from './internals/styles'
import { SearchNotice } from './internals/Notices'
import styled from '@emotion/styled'

interface Props {
	search?: SearchWithExtras
	handleClick?: (value: string) => void
	isSelected?: boolean
}

export const HistorySummaryCard = ({ search, handleClick, isSelected = false }: Props): JSX.Element => {
	const searchType = determineSearchType(search)
	const isClickable = handleClick && [SearchType.hasActiveOffers, SearchType.expired].includes(searchType)
	const summary = search?.summary
	const formattedCreatedDate = search?.created ? format(search?.created, 'MMM do') : ''
	const { width } = useResize()

	// TODO: Use the global media queries so not to leave magic numbers all over the place.
	const compactMode = width < 1024

	const showCTA = compactMode || [SearchType.expired, SearchType.noOffers].includes(searchType)
	const showDateInside = compactMode // shouldShowDateInside()
	return (
		<CardWrapper>
			{!showDateInside && <Date>{formattedCreatedDate}</Date>}
			<HistoryCard
				selected={isSelected}
				clickable={isClickable}
				onClick={(): void => {
					if (handleClick && isClickable && search?.id) {
						handleClick(search.id)
					}
				}}
			>
				<SearchSummaryContent search={search} showDate={showDateInside} constrainTrivia={compactMode}>
					<SearchNotice search={search} />
					{showCTA && <CallToActionButton search={search} />}
				</SearchSummaryContent>
				<ArrowWrapper>
					{summary?.offerCount ? <Arrow color={isSelected ? COLORS.SPANISH_GRAY : COLORS.KSU_PURPLE} /> : ''}
				</ArrowWrapper>
			</HistoryCard>
		</CardWrapper>
	)
}

const ArrowWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	width: 10%;
	@media screen and (${PAGE_BREAKPOINTS.DESKTOP_SMALL}) {
		display: none;
	}
`

const Date = styled.span`
	font-size: 14px;
	font-weight: bold;
	text-align: center;
	margin-top: 40px;
	margin-right: 20px;
	position: relative;
	min-width: 55px;

	&::after {
		width: 1px;
		height: 100%;
		background: ${COLORS.SPANISH_GRAY};
		content: '';
		position: absolute;
		left: 50%;
		top: 30px;
	}
`

const HistoryCard = styled(Card)`
	height: auto;
`
